// extracted by mini-css-extract-plugin
module.exports = {"list":"_229jk","item":"_36uL6"};